export default __webpack_public_path__ + "static/media/the-devil@2x.6f5fe501.png";